export const environment = {
  name: 'QA',
  production: false,
  apiBaseUrl: 'https://qa-api.actionledgers.com/api',
  externalAuthEnabled: true,
  amplitude: { enabled: true, apiKey: '72bd978b6867b83ab7b6c5c2773d231a', replayEnabled: false, replaySampleRate: 0 },
  googleMapsApiKey: 'AIzaSyCEVxx6oaJqH-IBCAIvazfTgJm3VhNtqMQ'
};
